import React from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardHeader, CCardBody,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import CurrencyInputs from '../../components/CurrencyInputs/CurrencyInputs';
import { connect } from 'react-redux';
import { updateCurrencyRequestAction } from '../../store/currency/currencyActions';
import { useTranslation } from '../../hooks/useTranslation';
const UpdateCurrency = ({ updateCurrencyRequest, isLoading, updateCurrencyData }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id: _id } = useParams();
  const { t } = useTranslation();
  const currencyData = location.state?.currency || null;

  const handleSubmit = (data) => {
    updateCurrencyRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/currency');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/currency" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          {t('currency')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('updateCurrency')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader>
              <h4>{t('updateCurrency')}</h4>
              {currencyData?.CurrencyId && (
                <small className="text-muted">ID: {currencyData.CurrencyId}</small>
              )}
            </CCardHeader>
            <CCardBody>
              {currencyData ? (
                <CurrencyInputs
                  onSubmit={handleSubmit}
                  onCancel={handleCancel}
                  isLoading={isLoading}
                  submitResponse={updateCurrencyData}
                  initialData={currencyData}
                  isEdit={true}
                />
              ) : (
                <div className="text-center">
                  <p>{t('noDataFound')}</p>
                </div>
              )}
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  updateCurrencyData: state.currencyReducer.updateCurrencyData,
});

const mapDispatchToProps = {
  updateCurrencyRequest: updateCurrencyRequestAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateCurrency);
